module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_top_advertisers-e9b1627d8912e07b402b75b402255df3.png";